// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1ghVi","footer":"ModalFilter_footer__1ZyXF"};